import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../../../config/queryClient'
import { QueryKeys } from '../../../../../enums/queryKeys'
import { ROOT_FOLDER_ID } from '../../../constants/rootFolderId'
import { useFetchFolderTree } from '../../../hooks/useFetchFolderTree'
import { fetchFolderContents } from '../../../query-api'
import { DmsFolderContents } from '../../../types'
import { mapFolderToFileListItem } from '../../../utils/mapFolderToFileListItem'
import { generateFolderPath } from '../utils/generateFolderPath'
import { getTargetedParentFolderIdFromFolderPath } from '../utils/getTargetedParentFolderIdFromFolderPath'

const prepareFoldersForMoveItemModal = (data: DmsFolderContents, folderIdsToExclude: string[]) => {
  const folders = data.folders.map(mapFolderToFileListItem)
  return folders.filter((folder) => !folderIdsToExclude.includes(folder.id))
}

export const useMoveItemModal = (parentFolderId: string | null, folderIdsToExclude: string[]) => {
  const { tree } = useFetchFolderTree()
  const { organization } = useUserOrganization()
  const { data: foldersList, isLoading } = useQuery(
    [QueryKeys.DmsFolderContents, parentFolderId],
    () => fetchFolderContents(organization?.id as string, parentFolderId ?? ROOT_FOLDER_ID),
    {
      enabled: !!organization?.id,
      staleTime: defaultStaleTime,
      select: (data) => prepareFoldersForMoveItemModal(data, folderIdsToExclude),
    },
  )

  const folderPath = generateFolderPath(parentFolderId, tree)
  const targetedParentFolderId = getTargetedParentFolderIdFromFolderPath(folderPath)

  return {
    targetedParentFolderId,
    isLoading,
    folderPath,
    foldersList,
  }
}
